import { Dropbox } from 'dropbox'

export const dropbox = new Dropbox({
  accessToken: 'b9-iS6hViEgAAAAAAAAjd996EfWtvwlZ7Ivz-5VWg4M95mW8OkFM_xLXJeRJU7-b',
  fetch: window.fetch
})
